/* Componente per selezionare il campo per eseguire la query */
import React from 'react';
import {useEffect} from 'react'
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
const useStyles = makeStyles((theme) => ({
  selectEmpty: {
    marginTop: theme.spacing(0),
  },
}));

function SelectField(props) {
  
  var dataLayers = [{fieldLabel: "",
                      fieldName: "",
                      visible: false}]
  var flag = props.flag
  try {
     
    dataLayers = props.data.infoField.fields
  } catch (error) {
    
  }

  const classes = useStyles();
  const [status, setStatus] = React.useState(dataLayers[0].fieldLabel);
  // const [layerValue, setLayerValue] = React.useState('')

  useEffect(()=>{
    setStatus('')
    // setLayerValue('')
  },[props.start])

  const handleChange = (event) => {
  props.callback(dataLayers[event.target.value])
  setStatus(event.target.value);
  // setLayerValue(dataLayers[event.target.value])
  };
  const select =(dati,index)=>{
      return (

        <MenuItem key={index} value={index} >
        {dati.fieldLabel}
      </MenuItem>
      )
  }

  return (
    
        <FormControl className={"formControl"} >
        <Select
        
          value={status}
          onChange={handleChange}
          displayEmpty
          className={classes.selectEmpty}
          inputProps={{ 'aria-label': 'Without label' }}
          disabled={flag}
        >
          {dataLayers.map((item, index) => (
            
           item.visible ? select(item,index) : null
          ))}
            
        </Select>
      </FormControl>
   )}


  export default SelectField